/**
 * Roles API - 권한 관리
 */

import apiClient from './client';

export interface Role {
  roleId: string;
  roleName: string;
  description?: string;
  sortOrder?: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRoleInput {
  roleId: string;
  roleName: string;
  description?: string;
  sortOrder?: number;
}

export interface UpdateRoleInput {
  roleName?: string;
  description?: string;
  sortOrder?: number;
}

export const roleApi = {
  /** 권한 목록 조회 */
  async list(): Promise<Role[]> {
    const res = await apiClient.get<{ success: boolean; data: Role[] }>('/api/roles');
    return res.data.data;
  },

  /** 권한 단건 조회 */
  async get(roleId: string): Promise<Role> {
    const res = await apiClient.get<{ success: boolean; data: Role }>(`/api/roles/${roleId}`);
    return res.data.data;
  },

  /** 권한 생성 */
  async create(input: CreateRoleInput): Promise<Role> {
    const res = await apiClient.post<{ success: boolean; data: Role }>('/api/roles', input);
    return res.data.data;
  },

  /** 권한 수정 */
  async update(roleId: string, input: UpdateRoleInput): Promise<Role> {
    const res = await apiClient.patch<{ success: boolean; data: Role }>(`/api/roles/${roleId}`, input);
    return res.data.data;
  },

  /** 권한 삭제 */
  async delete(roleId: string): Promise<void> {
    await apiClient.delete(`/api/roles/${roleId}`);
  },

  /** 시스템 기본 권한 초기화 */
  async initSystemRoles(): Promise<void> {
    await apiClient.post('/api/roles/init');
  },
};

export default roleApi;
